import React from "react";
import { MDBBtn, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import BlackMode from "../../components/NightMode/BlackTheme";
import { new_admin_domain } from "../../apiclients/apiurls";

export default function NotFound404(props) {
  const navigate = useNavigate();
  function tgoBack(e) {

    navigate(-1);
  }
  return (
    <MDBContainer>
      <div className="d-none" >
        <Header />
        <BlackMode />
      </div>
      <MDBRow>
        <div className="col-12">
          <section className="my-5 text-center">
            <h1 className="display-1">404</h1>

            <h4 className="mb-4">Page not found</h4>

            <p className="mb-0">
              The Page you are looking for doesn't exist or an other error
              eccured.
            </p>
            <p className="mb-4">
              Go back, or ahead over to <a href={`${new_admin_domain}home`}>{`${new_admin_domain}home`}</a> to choose a new direction.
            </p>

            <MDBBtn onClick={(e) => tgoBack(e)} className="me-2 btn btn-primary">Go back</MDBBtn>
            <Link to="/home">
              <MDBBtn className="me-2 btn btn-primary">Home</MDBBtn>
            </Link>
          </section>
        </div>
      </MDBRow>
    </MDBContainer>
  );
}
